import { useState } from "react";
import { Text } from "react-native";
import {
  Form,
  Input,
  Label
} from "@/app/(auth)/login";
import { useResetPasswordMutation } from "@/_store/auth/auth.slice";
import { useRouter } from "expo-router";
import { clearAuthError, setAuthError } from "@/_reducers/accounts.reducer";
import { useAppDispatch } from "@/_hooks";
import styled from "styled-components/native";
import InfoAlert from "@/app/components/InfoAlert";
import { validateResetPassword } from "@/_utils/validateAuth";
import CustomButton from "@/app/components/CustomButton";
import Container from "@/app/components/Container";
import useFocus from "@/_hooks/useFocus";
import { usePlatformStyles } from "@/_hooks/usePlatformStyles";

const ResetPassword = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");

  const emailFocus = useFocus();
  const { webOutlineNone } = usePlatformStyles();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const isButtonDisabled: boolean = !validateResetPassword({ email }) || isLoading;

  const handleResetPassword = async (): Promise<void> => {
    try {
      await resetPassword({ email }).unwrap();
      dispatch(clearAuthError())
      setIsSubmitted(true)
    } catch (err: any) {
      console.error(err);
      dispatch(setAuthError(err))
    }
  }

  if (isSubmitted) {
    return (
      <Container>
        <AlertWrapper>
          <InfoAlert
            textInfo={
              "Мы отправили ссылку для восстановления пароля на вашу почту. Пожалуйста, следуйте инструкциям в письме."
            }
          />
        </AlertWrapper>

        <CustomButton
          title="Назад к авторизации"
          type="text"
          onPress={() => router.push("/login")}
          textClassName="text-blue-500"
        />
      </Container>
    );
  }

  return (
    <Container>
      <Text className="text-header">Восстановление пароля</Text>
      <Text className="text-subhead">Пожалуйста, введите адрес электронной почты используемый в сервисе.</Text>
      <Form>
        <Label>Email</Label>
        <Input
          placeholder="Введите ваш email"
          placeholderTextColor="#9FABBE"
          value={email}
          onChangeText={setEmail}
          autoCapitalize="none"
          keyboardType="email-address"
          underlineColorAndroid="transparent"
          onFocus={emailFocus.onFocus}
          isFocused={emailFocus.isFocused}
          onBlur={emailFocus.onBlur}
          style={webOutlineNone}
        />

        <CustomButton
          title="Сбросить пароль"
          type="primary"
          className="mb-6"
          onPress={handleResetPassword}
          disabled={isButtonDisabled}
        />
      </Form>

      <CustomButton
        title="Назад к авторизации"
        type="text"
        onPress={() => router.push("/login")}
        textClassName="text-blue-500"
      />
    </Container>
  );
};

export default ResetPassword;

export const AlertWrapper = styled.View`
  width: 100%;
  margin-bottom: 16px;
`;
